"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var Dropdown_1 = __importDefault(require("./Dropdown"));
var styles_1 = __importDefault(require("./styles"));
var dom_1 = require("../../helpers/dom");
var Item_1 = __importDefault(require("./Item"));
// tslint:disable: max-line-length
var Select = function (_a) {
    var value = _a.value, isHidden = _a.isHidden, className = _a.className, style = _a.style, isDisabled = _a.isDisabled, isInvalid = _a.isInvalid, options = _a.options, labelProp = _a.labelProp, onChange = _a.onChange, placeholder = _a.placeholder, form = _a.form;
    if (isHidden)
        return null;
    var ref = react_1.useRef();
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    // const [ selected, setSelected ] = useState<IOption | void>(initialValue)
    var isDisabledOrEmpty = isDisabled || !options || !!options && !options.length;
    var classNames = "\n    select-container\n    " + (className || '') + "\n    " + (value ? 'filled' : '') + "\n    " + (isOpen ? 'active' : '') + "\n    " + (isInvalid ? 'invalid' : '') + "\n    " + (isDisabledOrEmpty ? 'disabled' : '') + "\n";
    var handleChange = function (option) {
        // setSelected(option)
        onChange(option);
        setIsOpen(false);
    };
    var handleIconClick = function (event) {
        event.stopPropagation();
        setIsOpen(!isDisabledOrEmpty && !isOpen);
    };
    var items = options.map(function (x) {
        return react_1.default.createElement(Item_1.default, { key: x.id, isSelected: (value === null || value === void 0 ? void 0 : value.id) === x.id, onClick: handleChange.bind(undefined, x) }, x[labelProp]);
    });
    var handleDocumentClick = function (event) {
        if ((isOpen && !dom_1.isChildNode(ref.current, event.target)) || ref.current !== event.target)
            setIsOpen(false);
    };
    react_1.useEffect(function () {
        // if (form) form.addEventListener('reset', setSelected.bind(undefined, initialValue ?? []))
        document.addEventListener('click', handleDocumentClick);
        return function () {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, [form]);
    // useEffect(() => {
    //   if (initialValue !== selected) setSelected(initialValue)
    // }, [initialValue])
    return (react_1.default.createElement(styles_1.default, { className: classNames, style: style, onClick: setIsOpen.bind(undefined, !isDisabledOrEmpty && !isOpen), ref: ref },
        react_1.default.createElement("input", { className: "value", placeholder: placeholder, readOnly: true, value: value ? value[labelProp] : '' }),
        react_1.default.createElement(Icon_1.default, { className: "icon", icon: isOpen && !isDisabledOrEmpty ? 'up' : 'down', onClick: handleIconClick }),
        react_1.default.createElement(Dropdown_1.default, { parentRef: ref, isHidden: !isOpen || isDisabledOrEmpty }, items)));
};
exports.default = Select;
//# sourceMappingURL=index.js.map